import React from 'react';
import { Hero } from './presell/Hero';
import { EverydayMobility } from './presell/EverydayMobility';
import { Discovery } from './presell/Discovery';
import { Solution } from './presell/Solution';
import { LifestyleBenefits } from './presell/LifestyleBenefits';
import { SocialProof } from './presell/SocialProof';
import { FinalCta } from './presell/FinalCta';
export function PresellPage() {
  return <div className="w-full bg-white" data-id="element-83" data-mp="2ivxb6eq8m89k">
      <header className="w-full bg-white border-b border-[#E5E9E7]" data-id="element-84" data-mp="2ix00wjbtq4nw">
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-5 flex justify-center" data-id="element-85" data-mp="2dyorg9pfxw67">
          <p className="text-xl md:text-2xl font-bold text-[#22322C] tracking-tight" data-id="element-86" data-mp="2sn1qxgnqlx5g">
            Dr. Weis{' '}
            <span className="font-light italic text-[#7C9082]" data-id="element-87" data-mp="2nvjr4vxga2m2">
              Joint Research
            </span>
          </p>
        </div>
      </header>

      <main className="w-full" data-id="element-88" data-mp="203w3qnzed9oj">
        <Hero data-id="element-89" data-mp="1v7nvlujmagqv" />
        <EverydayMobility data-id="element-90" data-mp="1v63124xayxt0" />
        <Discovery data-id="element-91" data-mp="1v6vy2e6gm8xy" />
        <Solution data-id="element-92" data-mp="1v5bd9g9y64da" />
        <LifestyleBenefits data-id="element-93" data-mp="1coivb4mgqzn" />
        <SocialProof data-id="element-94" data-mp="1bdk5pq1a9fe" />
        <FinalCta data-id="element-95" data-mp="1c6fzvngfeir" />
      </main>

      <footer className="w-full bg-[#F7F9F8] border-t border-[#E5E9E7]" data-id="element-96" data-mp="5e0crsuj3ydn">
        <div className="max-w-3xl mx-auto px-5 md:px-8 py-10 text-center space-y-4" data-id="element-97" data-mp="5c7304omcy1f">
          <p className="text-xs text-[#8A9A8F] leading-relaxed" data-id="element-98" data-mp="a5a18q4ccvny">
            The statements on this page have not been evaluated by the Food and
            Drug Administration. This content is for informational purposes only
            and is not intended to diagnose, treat, cure, or prevent any
            disease. Individual experiences vary. Consult your physician before
            starting any new supplement.
          </p>
          <p className="text-xs text-[#8A9A8F] leading-relaxed" data-id="element-99" data-mp="3siq061f6kgtq">
            This page contains affiliate links. We may receive compensation if
            you purchase through them.
          </p>
          <p className="text-sm text-[#8A9A8F]" data-id="element-100" data-mp="12vs5hugsx32y">
            © {new Date().getFullYear()} Dr. Weis Joint Research. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>;
}